import $ from "jquery";

import Field from "./../field";
import Dropdown from "./dropdown";

const PropertyTypes = (($) => {
  const OptionList = [
    { label: "Single Family Home", value: "Single Family" },
    { label: "Multi-Family", value: "Multi-Family" },
  ];
  return (field) => {
    return new Dropdown({ ...field, options: OptionList });
  };
})($);
export default PropertyTypes;
